import React from 'react';
import styled from 'styled-components';

const PageContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 6rem;
  height: 100%;
`;

function AuthContainer(props) {
  return <PageContainer>{props.children}</PageContainer>;
}

export default AuthContainer;
